import { Component, h, Host, Element, Listen } from '@stencil/core';
import { PassiveListenerHelper } from '../../../../../shared/helpers/passive-listener.helper';

@Component({
  tag: 'contact-phone-header',
})
export class ContactPhoneHeader {
  private readonly collapsedClassName = 'hidden';
  private readonly toggleButtonSelector = '[data-click-button]';
  private readonly togglingAreaSelector = '[data-toggling-area]';

  get togglingArea(): HTMLElement {
    return this.element.querySelector(this.togglingAreaSelector);
  }

  @Element() element: HTMLElement;

  @Listen('click')
  componentClick(ev) {
    ev.stopPropagation();
  }

  @Listen('click', { target: 'document' })
  documentClick() {
    this.togglingArea?.classList.add(this.collapsedClassName);
  }

  componentDidRender() {
    this.initDropdownClickListener();
  }

  initDropdownClickListener() {
    const button = this.element.querySelector(this.toggleButtonSelector);

    button.addEventListener('click', () => {
      const isDropdownCollapsed = Array.from(this.togglingArea.classList).includes(this.collapsedClassName);
      this.togglingArea.classList[isDropdownCollapsed ? 'remove' : 'add'](this.collapsedClassName);
    }, PassiveListenerHelper.passiveSupported ? { passive: true } : false);
  }

  render() {
    return <Host>
      <slot />
    </Host>;
  }
}
